import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { ClearGuideProgress, SaveGuideProgress } from './guide-progress.actions';

/** Older progress is ignored, so a guide left halfway does not come back days later. */
export const GUIDE_PROGRESS_TTL_MS = 30 * 60 * 1000;

/** Step an Amplitude guide moved to, so a reload on that page can reopen it. */
export interface GuideProgress {
  guideKey: string;
  step: number;
  /** Route path of the page that shows `step`. */
  path: string;
  /** `userId|companyId`, the Amplitude user id. Progress never carries over to another user. */
  ownerId: string;
  savedAt: number;
}

export interface GuideProgressStateModel {
  progress: GuideProgress | null;
}

/** Progress to resume for this user, or null when there is none or it is too old. */
export function resumableGuideProgress(
  progress: GuideProgress | null,
  ownerId: string | null,
  now = Date.now(),
): GuideProgress | null {
  if (!progress || !ownerId || progress.ownerId !== ownerId || now - progress.savedAt > GUIDE_PROGRESS_TTL_MS) {
    return null;
  }

  return progress;
}

@State<GuideProgressStateModel>({
  name: 'guideProgress',
  defaults: {
    progress: null,
  },
})
@Injectable()
export class GuideProgressState {
  @Selector()
  static progress(state: GuideProgressStateModel) { return state.progress; }

  @Action(SaveGuideProgress)
  save(ctx: StateContext<GuideProgressStateModel>, { progress }: SaveGuideProgress) {
    ctx.patchState({ progress });
  }

  @Action(ClearGuideProgress)
  clear(ctx: StateContext<GuideProgressStateModel>) {
    ctx.patchState({ progress: null });
  }
}
